import { SupportRequestStatusEnum } from "@/app/entities/SupportRequest"
import { httpClient } from "../http/httpClient"

interface updateSupportRequestParams {
  number: string
  status?: SupportRequestStatusEnum
  comment?: string
  resolution?: string
}
export const updateSupportRequest = async ({ number, status, comment, resolution }: updateSupportRequestParams) => {
  const response = await httpClient.put(`/support-requests/${number}`, { status, comment, resolution })
  return response.data
}
